import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TextAndImagesList.css';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import MarketingTool2Modal from './Modals/MarketingTool2Modal';

function MarketingTool2List() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CITLST NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CITLST_A1">
          <FontAwesomeIcon icon={faGift} />
        </div>
        <div className="CITLST_A2">
          Referrals
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <MarketingTool2Modal />
      </Modal>
    </div>
  );
}

export default MarketingTool2List;
